// Store de portais — lista de portais, logins e CNPJs gerenciados
import { apiGet, apiPost } from '@/api/conserv';
import eventBus from '@/views/eventBus';

// Lista todos os portais disponíveis no sistema
export async function listaPortais() {
    return apiGet('api/Portais/ListaPortais');
}

// Lista os CNPJs gerenciados pelo usuário (para combo gerenciadoras)
export async function listaCnpjGer() {
    return apiGet('api/Portais/ListaCnpjGer');
}

// Lista os logins de portais cadastrados pelo usuário.
// cnpj opcional (multi-CNPJ): lista os logins de outra empresa gerenciada; vazio = empresa ativa
export async function listaLoginsPortais(cnpj = '') {
    const extra = cnpj ? `?cnpj=${encodeURIComponent(cnpj)}` : '';
    return apiGet(`api/Portais/ListaLoginsPortais${extra}`);
}

// Testa os cookies/token de um login no portal.
// variante: usada quando o mesmo login atende a mais de um site do portal
// (Licitações-e: 'bb1' = legado, 'bb2' = novo).
export async function testaCookiesToken(cnpj, idportal, variante = '') {
    const extra = variante ? `&variante=${encodeURIComponent(variante)}` : '';
    return apiGet(`api/Portais/TestaCookiesToken?cnpj=${cnpj}&idportal=${idportal}${extra}`);
}

// Situação do login que espera o suporte resolver o captcha (captcha assistido pelo ADM).
// Retorna { ok, msg, data: { estado, pendente } }; estado: nenhum | aguardando_suporte | em_atendimento | concluido | falhou | expirado.
export async function statusLoginAssistido(cnpj, idportal) {
    return apiGet(`api/Portais/StatusLoginAssistido?cnpj=${cnpj}&idportal=${idportal}`);
}

// Testa login no portal via sistema
export async function testeLoginPortal(cnpj, idportal) {
    return apiPost('api/Sistemas/TesteLoginPortal', { cnpj, idportal });
}

// ComprasBR: empresas (perfis de fornecedor) que o login dá acesso — [{ chave, nome, selecionado }]
export async function listaPerfisComprasBR(cnpj) {
    return apiGet(`api/Portais/PerfisComprasBR?cnpj=${encodeURIComponent(cnpj)}`);
}

// ComprasBR: grava qual empresa do login usar (login com mais de uma empresa)
export async function escolhePerfilComprasBR(cnpj, chave) {
    return apiPost('api/Portais/EscolhePerfilComprasBR', { cnpj, chave });
}

// Exclui um login de portal cadastrado
export async function deletaLoginPortal(id) {
    const resp = await apiGet(`api/Portais/DeletaLoginPotal?id=${id}`);
    if (resp?.ok) eventBus.emit('logins-portais-atualizados');
    return resp;
}

// Grava (insere ou atualiza) um login de portal
export async function gravaLoginPortal(dados) {
    const resp = await apiPost('api/Portais/GravaLoginPotal', dados);
    // Avisa o cabeçalho para reavaliar o badge de sincronização sem esperar a consulta periódica
    if (resp?.ok) eventBus.emit('logins-portais-atualizados');
    return resp;
}

// Portais com login ligado e "sincronizar meus pregões" marcado (empresa ativa) — usado pelo cabeçalho
export async function listaPortaisQueSincronizam() {
    return apiGet('api/Portais/PortaisQueSincronizam');
}

// Recursos de cada portal no web e no desktop (configurados no ADM) — tela "Recursos disponíveis".
// silent: se falhar, a tela usa o arquivo local sem mostrar erro ao usuário.
export async function listaRecursosDisponiveis() {
    return apiGet('api/Portais/RecursosDisponiveis', { silent: true });
}
